import React, { FC } from 'react';
import GroupLayout from './GroupLayout';

interface IProps {
  children?: React.ReactNode;
}

const InputsGroupLayout: FC<IProps> = (props) => {
  const { children } = props;

  return <GroupLayout gutter={20}>{children}</GroupLayout>;
};

export default InputsGroupLayout;
